import { createSlice, PayloadAction, Slice } from '@reduxjs/toolkit';
import { OperationStatus } from '../../types';
import { initialState, User, UserInitialState } from '../../types/user';
import ApiError from '../../types/error';

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    getUserRequest: (state: UserInitialState) => {
      state.getUser = {
        error: null,
        status: OperationStatus.RUNNING
      };
    },
    getUserSuccess: (state: UserInitialState, action: PayloadAction<User>) => {
      state.getUser = {
        error: null,
        status: OperationStatus.COMPLETED
      };
      state.user = action.payload;
    },
    getUserFailure: (
      state: UserInitialState,
      action: PayloadAction<ApiError>
    ) => {
      state.getUser = {
        error: action.payload,
        status: OperationStatus.ERRORED
      };
    },
    getUserCleanup: (state: UserInitialState) => {
      state.getUser = initialState.getUser;
    }
  }
});

export const {
  getUserRequest,
  getUserSuccess,
  getUserFailure,
  getUserCleanup
} = userSlice.actions;

const userSliceExport: Slice<UserInitialState> = userSlice;

export default userSliceExport;
